import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_v59f599x2t: FaireBrandEntity = {
  token: "b_v59f599x2t",
  type: "brand",
  name: "Plant of Life",
  avatarUrl:
    "https://cdn.faire.com/fastly/47435076361771428faa1fa256731a5fa61968e3dba065594a8f16e36d4c0ab1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/76aca3712bd90c55211b5455169c6658dbc752f30b1a67c3347f399870e47460.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/47435076361771428faa1fa256731a5fa61968e3dba065594a8f16e36d4c0ab1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/76aca3712bd90c55211b5455169c6658dbc752f30b1a67c3347f399870e47460.jpeg",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 20,
  isInsider: false,
  description:
    "Discover the Power of Plants\n\nPlant of Life® was founded with a belief that the true potential of healing lies within the power of plants. Our focus is to source only from top quality natural ingredients to harness the effective healing elements of the plants. Through devoted research in discovering the best plant genetics and various methods of extraction, we’ve come to share our powerful and innovative formulas with the world.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:34.343Z",
    importedBy: "entity-db-cli",
  },
};
